import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import AlertBarsComponent from './js/alert-bars.component';

ComponentsFactory.getInstance().define('alert-bars', AlertBarsComponent);
